export default __webpack_public_path__ + "static/media/isotype_gransfer.35e09a66.svg";